import { useSuspenseInfiniteQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Profession } from 'src/shared/features/users/schemas/profession'
import type { Referral } from 'src/shared/schemas/referrals/referral'

const getReferralsByUser = (params: {
  skip?: number
  limit?: number
  query?: string
  exclude_profession?: Profession
  is_closed?: boolean
  needs_action?: boolean
}) => getRequest<Referral[]>('/referrals/me', params)

export const useMyReferrals = (params: {
  query?: string
  exclude_profession?: Profession
  is_closed?: boolean
  needs_action?: boolean
}) => {
  return useSuspenseInfiniteQuery({
    queryKey: queries.referrals.list({
      query: params.query,
      exclude_profession: params.exclude_profession,
      is_closed: params.is_closed,
      needs_action: params.needs_action,
    }).queryKey,
    queryFn: ({ pageParam = 0 }) =>
      getReferralsByUser({
        skip: pageParam,
        limit: 6,
        query: params.query,
        exclude_profession: params.exclude_profession,
        is_closed: params.is_closed,
        needs_action: params.needs_action,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage && lastPage.length === 6) {
        return pages.length * 6
      }
      return undefined
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
